import { useTheme } from '@emotion/react'
import { Chip } from '@mui/material'
import { OutreachStatus } from '__generated__/graphql'
import { formatDate } from 'date-fns'
import { getOutreachStatusLabel } from 'shared/utils'

const OutreachStatusPill = ({
    status,
    nonPoachDate,
    showLabel,
    sx,
}: {
    status: any
    nonPoachDate: any
    showLabel?: boolean
    sx?: React.CSSProperties
}) => {
    const theme = useTheme()
    const backgroundColor = (() => {
        switch (status) {
            case OutreachStatus.NonPoach:
                return theme.palette.status.orange
            case OutreachStatus.TreadCarefully:
                return theme.palette.status.purple
            case OutreachStatus.CpiPlaced:
                return theme.palette.status.blue
            default:
                return theme.palette.status.grey
        }
    })()

    const displayStatus =
        nonPoachDate && status === OutreachStatus.NonPoach
            ? `${getOutreachStatusLabel(status)} (${formatDate(nonPoachDate, 'MM/dd/yy')})`
            : getOutreachStatusLabel(status)

    return (
        <Chip
            title="Off Limits Status"
            size="small"
            label={showLabel ? `Off Limits: ${displayStatus}` : displayStatus}
            sx={{
                backgroundColor,
                color: theme.palette.greyscale.white,
                ...sx,
            }}
        />
    )
}

export default OutreachStatusPill
